<template>
  <div>
    <v-dialog v-model="dialog" 
      persistent
      width="450">
      <v-card class="border-radius box-shadow">
        <v-card-title class="d-flex justify-end pb-0">
          <v-icon style="position: absolute; right: 4px;" color="red" class="cursor-pointer" @click="dialog = false">mdi-close-circle-outline</v-icon>
        </v-card-title>
        <v-card-text class="body-2 text-first py-5">
          Apakah anda yakin menyetujui pembatalan booking atas nama <b>{{ detail.user_name }}</b> tipe unit <b>{{ detail.unit_type_name }}</b> blok <b>{{ detail.unit_label }}</b> ?
        </v-card-text>
        <v-card-text>
          <p class="font-weight-bold mb-2">
            Alasan Pembatalan :
          </p>
          <p class="font-italic mb-0">
            "{{ detail.transaction_canceled_review_note }}"
          </p>
        </v-card-text>
        <v-card-text>
          <p class="mb-2">
            *Catatan (bisa dikosongi)
          </p>
          <v-textarea
            v-model="form.note"
            auto-grow
            outlined
            :color="style.primary"
            rows="1">
          </v-textarea>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-5 px-6">
          <v-spacer/>
          <v-btn
            :color="style.primary"
            class="text-capitalize white--text mx-1"
            :loading="process.approve"
            :disabled="process.approve || process.reject"
            @click="confirmation('approved')">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Ya, Setujui
          </v-btn>
          <v-btn 
            outlined 
            color="red"
            class="text-capitalize red--text"
            :loading="process.reject"
            :disabled="process.reject || process.approve"
            @click="confirmation('')">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            Tolak Pembatalan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" class="py-0">
        <v-card flat min-height="800">
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0':''">
            <v-row>
              <v-col cols="12" md="5" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                
              </v-col>
              <v-col cols="12" md="4" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                <v-text-field
                  outlined
                  dense
                  :hide-details="true"
                  placeholder="Cari Pembatalan Booking . . ."
                  clearable
                  :color="style.primary"
                  v-model="filter.title"
                  @click:clear="filter.title = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  prepend-inner-icon="mdi-magnify">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                <v-select
                  dense
                  outlined
                  :items="[
                    {
                      label: 'Semua',
                      value: ''
                    },
                    {
                      label: 'Menunggu Konfirmasi Supervisor',
                      value: 'waiting'
                    },
                    {
                      label: 'Dibatalkan',
                      value: 'approved'
                    }
                  ]"
                  item-text="label"
                  item-value="value"
                  item-color="light-green lighten-2"
                  v-model="filter.status"
                  v-on:change="fetch()"
                  label="Status"
                  :color="style.primary"
                  hide-details>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mx-4"/>
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0 py-0':'py-0'" style="min-height: 600px;">
            <v-skeleton-loader
              :loading="process.run"
              transition="scale-transition"
              :tile="false"
              type="table-tbody">
              <v-simple-table>
                <template v-slot:default>
                  <thead v-if="!process.run && list.length > 0">
                    <tr>
                      <th class="text-left pl-0" width="300">Proyek</th>
                      <th class="text-left">Unit / Blok</th>
                      <th class="text-left">Konsumen</th>
                      <th class="text-left">Tanggal Pembatalan</th>
                      <th class="text-left" width="200">Status</th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="(item, index) in list" 
                      :key="index">
                      <td class="text-second pl-0">
                        {{ item.transaction_project_name }}
                      </td>
                      <td class="text-second">
                        <p class="mb-1">
                          {{ item.unit_type_name }} - {{ item.transaction_unit_name }}
                        </p>
                        <p class="text-third font-weight-bold mb-0" style="font-size: 10px;">
                          {{ parseInt(item.transaction_unit_price) | price }}
                        </p>
                      </td>
                      <td class="text-second">
                        <p class="mb-1">
                          {{ item.transaction_user_name }}
                        </p>
                        <p class="text-third font-weight-bold mb-0" style="font-size: 10px;">
                          {{ item.transaction_user_mobilephone }}
                        </p>
                      </td>
                      <td class="text-second text-capitalize">
                        <span v-if="item.transaction_canceled_review_status_datetime !== ''">
                          {{ item.transaction_canceled_review_status_datetime | date }}
                        </span>
                        <span v-else>
                          -
                        </span>
                      </td>
                      <td class="font-weight-bold text-capitalize">
                        <span class="color-default" v-if="item.transaction_canceled_review_status === 'waiting'">
                          Menunggu Persetujuan Supervisor
                        </span>
                        <span class="red--text" v-if="item.transaction_canceled_review_status === 'approved'">
                          Dibatalkan
                        </span>
                        <span class="red--text" v-if="item.transaction_canceled_review_status === '' && item.transaction_canceled_review_status_datetime !== ''">
                          Ditolak
                        </span>
                      </td>
                      <td class="text-right pr-0">
                        <v-btn v-if="item.transaction_canceled_review_status === 'waiting' && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor'))"
                          small
                          width="120"
                          outlined
                          :disabled="process.form"
                          :color="style.primary"
                          class="text-capitalize mx-1"
                          @click="dialog = true; detail = item;">
                          <v-icon small class="mr-1">mdi-check</v-icon>
                          Konfirmasi
                        </v-btn>
                        <v-btn v-if="item.transaction_canceled_review_status === 'waiting'"
                          small
                          width="120"
                          outlined
                          :disabled="process.form"
                          color="grey"
                          class="text-capitalize mx-1"
                          :href="`/project/unit/transaction/booking/${item.booking_id}?transaction=${item.transaction_id}&unit=${item.transaction_unit_id}`"
                          target="_blank">
                          <v-icon small class="mr-1">mdi-information-outline</v-icon>
                          Info Booking
                        </v-btn>

                        <v-btn v-if="item.transaction_canceled_review_status === 'approved' && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor') || user.user_company_roles_name.includes('administrator'))"
                          small
                          elevation="3"
                          class="text-capitalize white--text"
                          color="teal"
                          :disabled="process.form"
                          :loading="process.form && transaction_id === item.transaction_id"
                          @click="transaction_id = item.transaction_id; prints();">
                          <v-icon small color="white" class="mr-1">mdi-file-refresh-outline</v-icon>
                          Print Ulang Surat Pambatalan
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-skeleton-loader>
            <div class="d-flex align-center text-center text--secondary my-12 py-12" style="min-height: 550px;" v-if="!process.run && pagination.total_page < 1">
              <v-img 
                class="my-12"
                contain
                width="200"
                height="200"
                :src="require('../../assets/404/404.svg')">
              </v-img>
            </div>
            <v-divider/>
          </v-card-text>
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'pt-0':''">
            <v-row justify="end" align="center" v-if="pagination.total_page > 1">
              <v-col cols="12" md="2" class="d-flex align-center justify-end">
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === 1"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 mr-3"
                  @click="selected.pagination = 1">
                  <v-icon>mdi-chevron-double-left</v-icon>
                </v-btn>
                <v-btn
                  color="#263238"
                  :disabled="pagination.current < 2"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  @click="selected.pagination = selected.pagination-1">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <div class="mx-5" style="width: 75px;">
                  <v-autocomplete
                    v-model="selected.pagination"
                    :items="pagination.detail"
                    color="#263238"
                    auto-select-first
                    outlined
                    dense
                    single-line
                    hide-details
                    hide-selected>
                    <template v-slot:selection="{ item }">
                      {{ item }}
                    </template>
                  </v-autocomplete>
                </div>
                <v-btn
                  color="#263238"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  :disabled="pagination.current >= pagination.total_page"
                  @click="selected.pagination = selected.pagination+1">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === pagination.total_page"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 ml-3"
                  @click="selected.pagination = pagination.total_page">
                  <v-icon>mdi-chevron-double-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  export default {
    data () {
      return {
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Keterangan'
        },
        dialog: false,
        selected: {
          pagination: 1
        },
        transaction_id: '',
        filter: {
          title: '',
          status: ''
        },
        form: {
          note: ''
        },
        page: 1,
        list: [],
        pagination: {},
        detail: {},
        process: {
          run: false,
          form: false,
          approve: false,
          reject: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      'selected.pagination': function(val) {
        this.fetch(val)
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 12,
          search: this.filter.title,
          filter: [
            {
              type: 'string',
              field: 'transaction_canceled_review_status',
              value: this.filter.status
            }
          ]
        }

        await get(`auth/transaction/cancel-review/list`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)
          }
        })
      },
      async confirmation(type) {
        this.process.approve = type === 'approved' ? true : false
        this.process.reject = type === '' ? true : false

        await post(`auth/transaction/cancel`, {
          data: {
            trans_id: this.detail.transaction_id,
            notes: this.form.note,
            status: type
          }
        })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.approve = false
            this.dialog = false

            this.fetch()

            if (type === 'approved') window.open(res.data.url, '_blank')
          }
        })
      },
      async prints() {
        this.process.form = true

        let params = {
          transaction_id: this.transaction_id
        }

        await get(`auth/transaction/cancel/print`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            window.open(res.data.url, '_blank')
          }
        })
      }
    }
  }
</script>